module.exports = require('./base').extend();



//////////////////
// WEBPACK FOOTER
// ./~/vue-inject/src/index.js
// module id = 159
// module chunks = 40